import React from 'react';
import { Col, Form, Input } from 'antd';
import { I18n } from '@aws-amplify/core';

export function Greater() {
	return (
		<Col span={12}>
			<Form.Item name={['min_rpn']} label={I18n.get('Minimum')} labelCol={{ span: 24 }}>
				<Input placeholder={I18n.get('Minimum')} />
			</Form.Item>
		</Col>
	);
}
